import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BannerComponent } from './banner/banner.component';
import { SlickCarouselModule } from 'ngx-slick-carousel';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

const component = [BannerComponent];
const modules = [
  SlickCarouselModule
];

@NgModule({
  declarations: [...component], // spread the array
  imports: [CommonModule, ...modules, FormsModule, ReactiveFormsModule], // spread modules array too
  exports: [...component, ...modules], // spread here as well
})
export class SharedModule {}
